<div class="draggable">
  <div cdkDropList class="file-list" (cdkDropListDropped)="dropItem($event)">
    <div class="menu-item" *ngFor="let item of assignedItems; let i = index" cdkDrag cdkDragBoundary=".menu-item-list">
      <div class="drag-placeholder" *cdkDragPlaceholder></div>
      <p>{{item.title}}</p>
      <button class="drag ibexfusion-icon-button" mat-icon-button matTooltip="{{'packages.installedApps.dragTip'| translate}}">
        <mat-icon>drag_indicator</mat-icon>
      </button>
    </div>
  </div>
</div>
